import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const ContrastButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-adjust fa-fw"
        clickHandler={clickHandler}
        title={t('options.contrast')}
        id="contrastOptionButton"
        a11yAttributes={a11yAttributes}
    />);
};

ContrastButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default ContrastButton;
